import React, { useEffect, useState } from "react"
import { Alert, CardTitle, Container } from "reactstrap"
import PhoneVerification from "../KYC/phoneVerification"
import IDVerification from "../KYC/IDVerification"
import BankDetails from "../KYC/bankDetails"
import AdditionalDetails from "../KYC/additionalDetails"
import Signature from "../KYC/signature"
import CaptureSelfie from "../KYC/captureSelfie"
import KYCComplete from "../KYC/KYCComplete"
import PANCard from "../KYC/PANCard"
import BusinessAdditionalDetails from "../KYC/businessAdditionalDetails"
import { useSelector } from "react-redux"
import KycProgressBar from "./kycProgressBar"
import {
  useLazyGetKycDataQuery,
  useResolveQueryStepsQuery,
} from "store/api/kyc/kyc"
import toast from "react-hot-toast"
import KycFinalStep from "../KYC/kycFinalStep"
import AuthorisedSignatory from "../KYC/authorisedSignatory"
import KycAuthorityLetter from "../KYC/authorityLetter"
import KycFinalStepBusiness from "../KYC/KycFinalStepBusiness"
import { useNavigate } from "react-router-dom"
import MasterAgreement from "pages/KYC/agreementDetails"
import LoaderComponent from "components/loader"

const ResolveKyc = () => {
  const { user, userType } = useSelector((state) => state.user)
  const [currentStep, setCurrentStep] = useState("")
  const [kycData, setKycData] = useState(null)
  const navigate = useNavigate()
  const [getResult, { isFetching }] = useLazyGetKycDataQuery()
  const { data: querySteps } = useResolveQueryStepsQuery()

  useEffect(() => {
    if (kycData) {
      if (kycData?.status !== "QUERY_RAISED") {
        navigate("/")
      }
    }
  }, [kycData])

  useEffect(() => {
    setCurrentStep(querySteps?.data?.current_step)
  }, [querySteps])

  useEffect(() => {
    getKycData()
  }, [])

  const getKycData = async () => {
    try {
      const { success, message, data } = await getResult().unwrap()
      if (success) {
        setKycData(data)
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const getCurrentStepMessage = () => {
    let step = currentStep
    if (currentStep === "BANK_DETAILS") {
      step = "BANK_VERIFICATION"
    }
    if (currentStep === "GST_WAIVER") {
      step = "PAN_GST"
    }
    const item = querySteps?.data?.steps.find((item) => item.key === step)
    return item?.message
  }

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid pb-6">
            <div className="mb-5">
              <CardTitle className="mb-4 pt-4">Resolve KYC Query</CardTitle>
              {querySteps && (
                <KycProgressBar
                  querySteps={querySteps}
                  currentStep={currentStep}
                />
              )}
            </div>
            {isFetching && <LoaderComponent />}
            {!isFetching && kycData && (
              <div
                className={`pb-md-5 ${
                  currentStep !== "FINAL_STEP" ? "container-wrapper" : ""
                }`}
              >
                {currentStep !== "FINAL_STEP" && (
                  <div className="mt-md-5">
                    <Alert color="danger">
                      <h6>Admin Query: </h6>
                      {getCurrentStepMessage()}
                    </Alert>
                  </div>
                )}
                {currentStep === "PHONE_VERIFICATION" && (
                  <PhoneVerification
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {currentStep === "ID_VERIFICATION" &&
                  user.entity_type === "INDIVIDUAL" && (
                    <IDVerification
                      kycData={kycData}
                      querySteps={querySteps?.data?.steps}
                    />
                  )}
                {["BANK_VERIFICATION", "BANK_DETAILS"].includes(
                  currentStep
                ) && (
                  <BankDetails
                    currentStep={currentStep}
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {currentStep === "AGREEMENT_DETAILS" && (
                  <MasterAgreement
                    currentStep={currentStep}
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {currentStep === "ADDITIONAL_DETAILS" && (
                  <AdditionalDetails
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {currentStep === "BUSINESS_ADDITIONAL_DETAILS" && (
                  <BusinessAdditionalDetails
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {/* {currentStep === "SIGNATURE" && (
                  <Signature
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )} */}
                {currentStep === "PHOTO" && (
                  <CaptureSelfie
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {["PAN_GST", "GST_DETAILS", "GST_WAIVER"].includes(
                  currentStep
                ) && (
                  <PANCard
                    kycData={kycData}
                    currentStep={currentStep}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {["ID_VERIFICATION", "AUTHORISED_SIGNATORY"].includes(
                  currentStep
                ) &&
                  user.entity_type === "COMPANY" && (
                    <AuthorisedSignatory
                      kycData={kycData}
                      querySteps={querySteps?.data?.steps}
                    />
                  )}
                {currentStep === "AUTHORITY_LETTER" && (
                  <KycAuthorityLetter
                    kycData={kycData}
                    querySteps={querySteps?.data?.steps}
                  />
                )}
                {currentStep === "FINAL_STEP" &&
                  user.entity_type === "INDIVIDUAL" && (
                    <KycFinalStep
                      kycData={kycData}
                      querySteps={querySteps?.data?.steps}
                    />
                  )}
                {currentStep === "FINAL_STEP" &&
                  user.entity_type === "COMPANY" && (
                    <KycFinalStepBusiness
                      kycData={kycData}
                      querySteps={querySteps?.data?.steps}
                    />
                  )}
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    </>
  )
}

export default ResolveKyc
